import React, { useState } from 'react';

import { create, get } from '../redux/reducers'

import Movie from './Movie';
import { useDispatch } from 'react-redux'


function MovieNew(props) {
    const dispatch=useDispatch()

    
    const [objectInputState, setObjectInputState] = useState({
        "name": "nom du film",
        "thumbnail": null,
        "link": "lien du film sur allociné" ,
        "reviews":[]
    })

    const [editState, setEditState] = useState('EDIT')
    const [updateConclusionState, setUpdateConclusionState] = useState('NONE') //UPDATEPENDING, UPDATEFAILURE, UPDATEFULFILLED ; 

    const startSave = () => {
        dispatch(create("/api/movies/", objectInputState,(result) => {
            dispatch(get(props.reviewsObjectId)) //if i don't do that, my father won't display the new element. And my father is not using just /api/reviews/ but /api/reviews/blablablalba
            props.setCreateState("NOCREATE")}))
        props.setCreateState("CREATEPENDING")
    }

    return ( 
        <Movie
        type={props.type}

        objectInputState={objectInputState}
        setObjectInputState={setObjectInputState}

        editState={editState}
        setEditState={setEditState}
        updateConclusionState={updateConclusionState}
        setUpdateConclusionState={setUpdateConclusionState}

        startSave={startSave}

    />

     )
}

export default MovieNew;